import type { IntegritySignal, IntegritySignalKind } from '../rules/integritySignals';

export interface PrivateRunTrace {
  id: string;
  runId: string;
  ts: number;
  t: string;
  source: 'scheduled' | 'triggered' | 'client';
  signalCount: number;
  signals: IntegritySignal[];
  summaryKey: string;
  visibility: 'god_only';
}

export function normalizePrivateRunTrace(raw: Record<string, unknown>): PrivateRunTrace {
  const ts = raw.ts instanceof Date
    ? raw.ts.getTime()
    : typeof raw.ts === 'number'
      ? raw.ts
      : raw.ts && typeof raw.ts === 'object' && 'toDate' in raw.ts && typeof raw.ts.toDate === 'function'
        ? raw.ts.toDate().getTime()
        : Date.now();

  const date = new Date(ts);
  const signals = Array.isArray(raw.signals) ? raw.signals as IntegritySignal[] : [];

  return {
    id: String(raw.id ?? ''),
    runId: String(raw.runId ?? raw.id ?? ''),
    ts,
    t: date.toLocaleString([], { dateStyle: 'short', timeStyle: 'medium' }),
    source: (raw.source as PrivateRunTrace['source']) ?? 'scheduled',
    signalCount: signals.length,
    signals,
    summaryKey: signals.length > 0 ? 'integrity_trace_with_signals' : 'integrity_trace_clean',
    visibility: 'god_only',
  };
}

export function signalKindLabelKey(kind: IntegritySignalKind): string {
  return `integrity_kind_${kind}`;
}

export function formatIntegritySignal(
  signal: IntegritySignal,
  t: Record<string, string>,
): string {
  const template = t[signal.messageKey] ?? signal.messageKey;
  if (!signal.messageParams) return template;

  return Object.entries(signal.messageParams).reduce(
    (text, [key, value]) => text.replace(`{${key}}`, String(value)),
    template,
  );
}
